customElements.get("modal-gridy-slider-parent")||customElements.define("modal-gridy-slider-parent",class extends HTMLElement{constructor(){super(),document.querySelector("#MainContent").appendChild(this)}});
//# sourceMappingURL=/s/files/1/0004/2893/3175/t/27/assets/component-modal-gridy-slider.js.map?v=1739289790
